import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslationSyncService } from '../../services/translation-sync.service';

@Component({
  selector: 'app-imprint',
  imports: [TranslateModule],
  templateUrl: './imprint.component.html',
  styleUrl: './imprint.component.css'
})
export class ImprintComponent implements OnInit, AfterViewChecked {

  @ViewChild('imprintPage', { static: false }) containerRef!: ElementRef<HTMLElement>;

  isDarkMode: boolean;
  darkContainer: HTMLElement;

  constructor(
    private themeService: ThemeService
  , private sync: TranslationSyncService
  , public translate: TranslateService) {}


  ngAfterViewChecked(): void {
    this.registerAll(this.containerRef.nativeElement);
    this.darkContainer = document.getElementById('dark-container-imprintOverlay') as HTMLElement;

    // für data-transfe bei spracheinstellung
    this.registerAll(this.containerRef.nativeElement);
    this.registerAll(this.darkContainer);
  }

  ngOnInit(): void {
    this.themeService.isDarkMode$.subscribe(mode => {
      this.isDarkMode = mode;
      Promise.resolve().then(() => {
        const triggeredByToggle = this.themeService.wasThemeToggled();
      });
    });
  }

  private registerAll(root: HTMLElement) {
    const elems = Array.from(root.querySelectorAll<HTMLElement>('[data-translate]'));
    elems.forEach(el => {
      const key = el.getAttribute('data-translate')!;
      this.sync.register(el, key);
    });
  }

}
